import { ConflictError } from './engine.js';
export function createHttpTransport(request) {
    const call = async (method, path, body) => {
        const res = await request(method, path, body);
        if (res.status === 409) {
            const details = res.body?.error
                ?.details ?? {};
            throw new ConflictError(details);
        }
        if (res.status >= 400) {
            const msg = res.body?.error?.message ?? `HTTP ${res.status}`;
            throw new Error(msg);
        }
        return res.body;
    };
    return {
        registerDevice: (name, identityKey) => call('POST', '/e2ee/devices', { name, identityKey }),
        uploadKeyPackages: async (deviceId, keyPackages) => {
            for (let i = 0; i < keyPackages.length; i += 100) {
                await call('POST', `/e2ee/devices/${deviceId}/key-packages`, {
                    keyPackages: keyPackages.slice(i, i + 100),
                });
            }
        },
        keyPackageCount: async (deviceId) => (await call('GET', `/e2ee/devices/${deviceId}/key-packages/count`)).count,
        claimKeyPackages: (userIds, deviceIds) => call('POST', '/e2ee/key-packages/claim', {
            userIds,
            ...(deviceIds ? { deviceIds } : {}),
        }),
        userDevices: (userId) => call('GET', `/users/${userId}/devices?includeRevoked=true`),
        state: (channelId) => call('GET', `/channels/${channelId}/e2ee/state`),
        messages: (channelId, after) => call('GET', `/channels/${channelId}/e2ee/messages?limit=100${after ? `&after=${after}` : ''}`),
        post: (channelId, body) => call('POST', `/channels/${channelId}/e2ee/messages`, body),
        groupInfo: async (channelId) => {
            const res = await request('GET', `/channels/${channelId}/e2ee/group-info`);
            if (res.status === 404)
                return null;
            if (res.status >= 400)
                throw new Error(`HTTP ${res.status}`);
            return res.body;
        },
        putGroupInfo: async (channelId, body) => {
            await call('PUT', `/channels/${channelId}/e2ee/group-info`, body);
        },
        requestKeys: async (channelId, deviceId) => {
            await call('POST', `/channels/${channelId}/e2ee/request-keys`, { deviceId });
        },
        welcomes: (deviceId) => call('GET', `/e2ee/devices/${deviceId}/welcomes`),
        deleteWelcome: async (deviceId, welcomeId) => {
            await call('DELETE', `/e2ee/devices/${deviceId}/welcomes/${welcomeId}`);
        },
        reset: (channelId, generation) => call('POST', `/channels/${channelId}/e2ee/reset`, { generation }),
    };
}
/** In-memory store (tests, or a "don't remember this device" mode). */
export class MemoryStore {
    map = new Map();
    async get(key) {
        return this.map.get(key);
    }
    async set(key, value) {
        this.map.set(key, value);
    }
    async delete(key) {
        this.map.delete(key);
    }
    async keys(prefix) {
        return [...this.map.keys()].filter((k) => k.startsWith(prefix));
    }
}
//# sourceMappingURL=transport.js.map